import React, { useEffect } from 'react';
import image4 from './img/content/img-4.png';
import { useTranslation } from 'react-i18next';
import ShopsList from './shared/shopsList';

function ShopsPage() {

  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

    // ANALYTICS START
    var detectCurrentDevice = localStorage.getItem('deviceDetected');
    useEffect(() => {
      var headerWhite = document.querySelector('.wrap-header');
      var footerWhite = document.querySelector('.wrap-footer');
      headerWhite.classList.remove('box-header');
      footerWhite.classList.add('cookie-shop-page');
    })
    useEffect(() => {
      window.tc_vars = {
        'channel': detectCurrentDevice,
        'environment': "stg",
        'pagetemplate': "Valentino Lovely Courting Experience: Select your store",
        'site_languagecode': currentLanguage,
        '404': false,
        'pagename': "V:" + currentLanguage + ":valentine:select-store"
      };
      window._satellite.track('virtual_page_load', window.tc_vars);
      
      console.log("tc_vars", window.tc_vars);
      console.log("virtual_page_load", "activated");
    }, []);
    // ANALYTICS END

  return (  
    <div className="wrapper wrapper--page wrapper--page-stores">
      <div className="wrap">
        <div className="container">
          <div className="stores">
            <div className="stores__col stores__col--left">
              <picture className="stores__img">
                <img src={image4} width={649} height={694} alt="" />
              </picture>
            </div>
            <div className="stores__col stores__col--right">
            <h2>{t('SELECT_PREF_STORE_LABEL')}</h2>
            <ShopsList/>
          </div>
          </div>
        </div>
      </div>
      <div className="overflow-bg" />
    </div>
  );
}

export default ShopsPage;
